import {
	GET_SOURCE_BUSINESS,
	GET_SOURCE_BUSINESSES,
	ADD_SOURCE_BUSINESS,
	UPDATE_SOURCE_BUSINESS,
	REMOVE_SOURCE_BUSINESS,
	ERR_SOURCE_BUSINESS,
	LOADING_SOURCE_BUSINESS
} from "../actions/actionTypes";

const initialState = {
	sourceBusiness: null,
	sourceBusinesses: [],
	// loading: true,
	loading: false,
	errors: {},
};

export default function sourceBusinessReducer(state = initialState, action) {
	const { type, payload } = action;
	switch (type) {
		case GET_SOURCE_BUSINESSES:
			return {
				...state,
				sourceBusinesses:  payload,
				loading: false,
			};
		case GET_SOURCE_BUSINESS:
			return {
				...state,
				sourceBusiness: payload,
				loading: false,
			};
		case UPDATE_SOURCE_BUSINESS:
			return {
				...state,
				sourceBusinesses: state.sourceBusinesses?.data?.map((sourceBusiness) =>
					sourceBusiness?.brand_id === payload?.data?.brand_id
						? { ...sourceBusiness, payload }
						: sourceBusiness
				),
				loading: false,
			};
		case ADD_SOURCE_BUSINESS:
			return {
				...state,
				//sourceBusinesses: [payload.data, ...state.sourceBusinesses],
				loading: false,
			};
		case REMOVE_SOURCE_BUSINESS:
			return {
				...state,
				sourceBusinesses: state.sourceBusinesses?.data?.filter(
					(sourceBusiness) => sourceBusiness.brand_id !== payload.data
				),
				loading: false,
			};
		case ERR_SOURCE_BUSINESS:
			return {
				...state,
				errors: payload,
				loading: false,
			};
		case LOADING_SOURCE_BUSINESS:
			return {
				...state,
				loading: payload
			};
		default:
			return state;
	}
}
